/**
 * Sidebar — collapsed icon-only navigation with galaxy toggle.
 *
 * CSS: styles/components/sidebar.css
 */

import {
  iconFleet,
  iconWork,
  iconKB,
  iconGalaxy,
  iconDashboard,
  iconGraph,
  iconAnalytics,
} from './icons.js'
import { action } from './action-delegation.js'
import type { SidebarProps } from '../../types/components.js'

/** Render the sidebar. Always collapsed (56px icon-only). */
export function renderSidebar(props: SidebarProps): string {
  const isFleet = props.activePath === '/' || props.activePath === ''
  const isWork = props.activePath.startsWith('/work')
  const isKB = props.activePath.startsWith('/kb')
  const isPacks = props.activePath.startsWith('/packs')
  const isLogs = props.activePath.startsWith('/logs')
  const isGraph = props.activePath.startsWith('/graph')
  const isAnalytics = props.activePath.startsWith('/analytics')

  return `<aside class="sb">
    <div class="sb-brand">
      <a class="sb-bear" ${action('navigate', '/')} tabindex="0" role="link">&#x1F43B;</a>
    </div>
    <nav class="sb-nav">
      <a class="sb-item${isFleet ? ' active' : ''}" id="nav-fleet" ${action('navigate', '/')} title="Fleet" role="link">${iconFleet()}</a>
      <a class="sb-item${isWork ? ' active' : ''}" id="nav-work" ${action('navigate', '/work')} title="Work Items" role="link">${iconWork()}</a>
      <a class="sb-item${isKB ? ' active' : ''}" id="nav-kb" ${action('navigate', '/kb')} title="Knowledge Base" role="link">${iconKB()}</a>
      <a class="sb-item${isPacks ? ' active' : ''}" id="nav-packs" ${action('navigate', '/packs')} title="Knowledge Packs" role="link">${iconKB()}</a>
      <a class="sb-item${isLogs ? ' active' : ''}" id="nav-logs" ${action('navigate', '/logs')} title="Agent Dashboard" role="link">${iconDashboard(18)}</a>
      <a class="sb-item${isGraph ? ' active' : ''}" id="nav-graph" ${action('navigate', '/graph')} title="Knowledge Graph" role="link">${iconGraph()}</a>
      <a class="sb-item${isAnalytics ? ' active' : ''}" id="nav-analytics" ${action('navigate', '/analytics')} title="Analytics" role="link">${iconAnalytics()}</a>
    </nav>
    <div class="sb-galaxy" ${action('toggleGalaxy')} title="Toggle Galaxy atmosphere">${iconGalaxy()}</div>
    <div class="sb-foot"><span class="dot-g"></span></div>
  </aside>`
}

/** Toggle galaxy atmosphere on/off. Exposed globally for onclick. */
export function toggleGalaxy(): void {
  document.body.classList.toggle('galaxy-off')
  const isOff = document.body.classList.contains('galaxy-off')
  localStorage.setItem('grz-galaxy', isOff ? 'off' : 'on')
}

/** Restore galaxy state from localStorage. Call once on app init. */
export function restoreGalaxy(): void {
  if (localStorage.getItem('grz-galaxy') === 'off') {
    document.body.classList.add('galaxy-off')
  }
}
